<template>
  <md-field :class="{'md-invalid': errors.has(fieldLabel) }">
    <label :for="fieldLabel">{{fieldLabel}}</label>
    <md-select v-model="form[fieldName]" :name="fieldLabel" :id="fieldId" v-validate="validations" md-dense :disabled="sending" v-if="isMultiple" multiple>
      <md-option value=""></md-option>
      <md-option v-for="(value, index) in values" :key="index" :value="value[valueId]" v-if="withId">{{value[valueId]}} - {{value[valueLabel]}}</md-option>
      <md-option v-for="(value, index) in values" :key="index" :value="value[valueId]" v-if="!withId" >{{value[valueLabel]}}</md-option>
    </md-select>
    <md-select v-model="form[fieldName]" :name="fieldLabel" :id="fieldId" v-validate="validations" md-dense :disabled="sending" v-if="!isMultiple">
      <md-option value=""></md-option>
      <md-option v-for="(value, index) in values" :key="index" :value="value[valueId]" v-if="withId">{{value[valueId]}} - {{value[valueLabel]}}</md-option>
      <md-option v-for="(value, index) in values" :key="index" :value="value[valueId]" v-if="!withId" >{{value[valueLabel]}}</md-option>
    </md-select>
    <span class="md-error" v-if="errors.has(fieldLabel)">{{ errors.first(fieldLabel) }}</span>
  </md-field>
</template>

<script>
export default {
  name: 'FieldSelect',
  data: () => ({
    form: {}
  }),
  props: ['fieldName', 'fieldLabel', 'fieldId', 'fieldValue', 'values', 'valueId', 'valueLabel', 'sending', 'validations', 'withId', 'isMultiple'],
  methods: {
    validateField () {
      return this.$validator.validate().then((result) => {
        this.$emit('setfield', {
          'fieldName': [this.fieldName],
          'fieldValue': this.form[this.fieldName]
        })
        return result
      })
    },
    clearField () {
      this.form[this.fieldName] = this.isMultiple ? [] : null
    }
  },
  created: function () {
    if (this.fieldValue) {
      this.form[this.fieldName] = this.fieldValue
    } else {
      this.form[this.fieldName] = this.isMultiple ? [] : null
    }
  }
}

</script>
